<ngx-loading [show]="loading"></ngx-loading>
<ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>

<div [ngStyle]="{ height: 'calc(100dvh - 75px)' }">
  <kendo-grid
    [data]="gridView"
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [sort]="gridState.sort"
    [sortable]="true"
    [selectable]="true"
    [style.height.%]="100"
    (add)="addHandler()"
    (edit)="editHandler($event)"
    (remove)="removeHandler($event)"
  >
    <ng-template kendoGridToolbarTemplate>
      <div class="d-flex">
        <span class="pl-4 search-box border border-radius">
          <span class="fa fa-search"></span>
          <mat-form-field class="w-75 p-3">
            <input matInput placeholder="Search..." aria-label="Search Packages" [formControl]="searchCtrl" />
            <button
              mat-button
              *ngIf="searchCtrl.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchCtrl.setValue('')"
            >
              <mat-icon><i class="fa fa-times-circle"></i></mat-icon>
            </button>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option id="searchDropdown" *ngFor="let package of filteredPackages | async" [value]="package.name">
                <span>{{ package.name }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
      <button *ngIf="editPolicySatisfied" kendoGridAddCommand class="btn em-btn">
        <i class="fal fa-plus-circle"></i> Add Package
      </button>
    </ng-template>

    <kendo-grid-column field="name" title="Name" [width]="150"></kendo-grid-column>
    <kendo-grid-column title="Service" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.serviceTemplate.serviceName }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="note" title="Note" [width]="150"></kendo-grid-column>
    <kendo-grid-column title="Service Price" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.serviceTemplate.defaultPrice | currency }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="quantity" title="Quantity" [width]="100"></kendo-grid-column>
    <kendo-grid-column title="Total Price" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.serviceTemplate.defaultPrice * dataItem.quantity | currency }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Override Price" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.price | currency }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column *ngIf="editPolicySatisfied" title="Actions" min-width="125px" [width]="125">
      <ng-template kendoGridCellTemplate let-isNew="isNew">
        <button kendoGridEditCommand class="btn kendo-btn"><i class="fas fa-edit"></i></button>
        <button kendoGridRemoveCommand class="btn kendo-btn"><i class="fas fa-minus-circle"></i></button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</div>

<app-actionpanel></app-actionpanel>
